/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliCreateStudentDto } from '../../models/amoxcalli-create-student-dto';
import { AmoxcalliStudentDtoApiResponse } from '../../models/amoxcalli-student-dto-api-response';

export interface ApiStudentsPost$Plain$Params {
      body?: AmoxcalliCreateStudentDto
}

export function apiStudentsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiStudentsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliStudentDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiStudentsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliStudentDtoApiResponse>;
    })
  );
}

apiStudentsPost$Plain.PATH = '/api/students';
